import { AtomMapUiPreferences } from '@atom/types/map';

export type MapStateAction =
  | { type: 'SET_STYLE'; mapStyle: AtomMapUiPreferences['mapStyle'] }
  | { type: 'SET_MAP_TYPE'; mapTypeId: AtomMapUiPreferences['mapTypeId'] }
  | { type: 'SET_TRAFFIC'; traffic: boolean }
  | { type: 'SET_POI'; poi: boolean };

export const mapStateReducer = (
  state: AtomMapUiPreferences,
  action: MapStateAction,
): AtomMapUiPreferences => {
  switch (action.type) {
    case 'SET_STYLE':
      return { ...state, mapStyle: action.mapStyle };
    case 'SET_MAP_TYPE':
      return { ...state, mapTypeId: action.mapTypeId };
    case 'SET_TRAFFIC':
      return { ...state, traffic: action.traffic };
    case 'SET_POI':
      return { ...state, poi: action.poi };
    default:
      return state;
  }
};
